import { render, staticRenderFns } from "./LiquidacionCreateView.vue?vue&type=template&id=243a671d&scoped=true&"
import script from "./LiquidacionCreateView.vue?vue&type=script&lang=js&"
export * from "./LiquidacionCreateView.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionCreateView.vue?vue&type=style&index=0&id=243a671d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a671d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VCardText,
  VFlex,
  VLayout,
  VProgressLinear,
  VSubheader,
  VTextField,
  VTextarea,
  VToolbar,
  VToolbarTitle,
})
